import Cropper from 'cropperjs';

let croppedImageData = null;

// direct_uploads.js
global.directUploadsInit = function () {
  addEventListener('direct-upload:initialize', (event) => {
    const { target, detail } = event;
    const { id, file } = detail;

    if (!$(`#direct-upload-${id}`)[0]) {
      target.insertAdjacentHTML(
        'beforebegin',
        `
        <div id="direct-upload-${id}" class="direct-upload direct-upload--pending">
          <div id="direct-upload-progress-${id}" class="direct-upload__progress" style="width: 0%"></div>
          <span class="direct-upload__filename">${file.name}</span>
        </div>
      `
      );
    }
  });

  addEventListener('direct-upload:start', (event) => {
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.remove('direct-upload--pending');
  });

  addEventListener('direct-upload:progress', (event) => {
    const { id, progress } = event.detail;
    const progressElement = document.getElementById(
      `direct-upload-progress-${id}`
    );
    progressElement.style.width = `${progress}%`;
  });

  addEventListener('direct-upload:error', (event) => {
    event.preventDefault();
    const { id, error } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add('direct-upload--error');
    element.setAttribute('title', error);
  });

  addEventListener('direct-upload:end', (event) => {
    const { id } = event.detail;
    const element = document.getElementById(`direct-upload-${id}`);
    element.classList.add('direct-upload--complete');
  });

  const previewImage = function (imageFile, fileInput, isModal = false) {
    const reader = new FileReader();

    reader.onload = (e) => {
      const placeholder = isModal ? $('#hero-upload-img .js-image-preview-placeholder') : $('.js-image-preview-placeholder');
      const preview     = isModal ? $('#hero-upload-img .image-preview') : $('.image-preview');
      const image       = isModal ? $('#hero-upload-img img.image-preview') : $('img.image-preview');

      placeholder.addClass('hidden');
      preview.removeClass('hidden');
      image.attr('src', e.target.result);
      if (image.hasClass('croppable')) {
        var el =  isModal ? document.querySelector('#hero-upload-img img.image-preview')
            : document.querySelector('img.image-preview');
        el.onload = function() {
          var width  = this.naturalWidth  || this.width;
          var height = this.naturalHeight || this.height;
          crop(image[0], { file: imageFile, input: fileInput }, width, height);
        }
      }

    };

    reader.readAsDataURL(imageFile);
  };

  function crop(image, { file, input }, width, height) {
    let cropper;

    const controls = $('.crop-zoom').removeClass('hidden');
    const enlarge  = controls.find('#zoomIn')[0];
    const shrink   = controls.find('#zoomOut')[0];

    const saveButton =  document.querySelector('#saveCroppedImage');

    function onChange() {
      cropper.getCroppedCanvas().toBlob(blob => {
        const transfer = new ClipboardEvent("").clipboardData || new DataTransfer();
        const cropped  = new File([blob], file.name, { type: blob.type });

        transfer.items.add(cropped);
        input.files = transfer.files;
      });
    }

    function onEnlarge() {
      cropper.zoom(0.1);
      shrink.removeAttribute('disabled');
    }

    function onShrink() {
      cropper.zoom(-0.1);
    }

    function saveCroppedImage(){
      cropper.getCroppedCanvas().toBlob(blob => {
        blobToBase64(blob).then(base64String => {
          croppedImageData = base64String;
          getCroppedImage();
        }).catch(error => {
          console.error('Error converting Blob to Base64:', error);
        });
      });
    }

    function getCroppedImage(){
      if (croppedImageData) {

        const formData = new FormData(this);
        formData.append('article[hero_base_64]', croppedImageData);
        formData.append('article[aspect_ratio]', cropper.getImageData().aspectRatio.toString());

        // Submit the form with the cropped image data
        fetch('/articles/save_cropped_image', {
          method: 'POST',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: formData
        })
            .then(response => {
              if (response.ok) {
                return response.json();
              }
              throw new Error('Network response was not ok.');
            })
            .then(data => {
              const $croppedImageCon = $('img.blog-hero.cropped_image');
              $croppedImageCon.attr('src', data.updated_image_url);

              $('#article_hero_input').val(data.updated_image_url);

              if (cropper.getImageData().aspectRatio >= 1.0) {
                $croppedImageCon.addClass('landscape');
                $croppedImageCon.removeClass('portrait');
              }else if (cropper.getImageData().aspectRatio < 1.0) {
                $croppedImageCon.addClass('portrait');
                $croppedImageCon.removeClass('landscape');
              }

              // cropper.getImageData().aspectRatio > 1.0 ? $croppedImageCon.addClass('landscape') : $croppedImageCon.addClass('portrait');
              $('img.blog-hero.hidden.cropped_image').removeClass('hidden');
              $('.image-preview-placeholder.blog-hero').addClass('hidden');
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        // Prevent the default form submission since we're handling it via fetch
        event.preventDefault();
      }
    }

    function onDestroy() {
      cropper.destroy();
      image.removeEventListener('cropend', onChange);
      image.removeEventListener('zoom', onChange);
      input.removeEventListener('change', onDestroy);
      enlarge.removeEventListener('click', onEnlarge);
      shrink.removeEventListener('click', onShrink);
      shrink.setAttribute('disabled', '');
      if (saveButton){saveButton.removeEventListener('click', saveCroppedImage);}
    }

    input.addEventListener('change', onDestroy);
    image.addEventListener('cropend', onChange);
    image.addEventListener('zoom', onChange);
    enlarge.addEventListener('click', onEnlarge);
    shrink.addEventListener('click', onShrink);
    if (saveButton){saveButton.addEventListener('click', saveCroppedImage);}

    cropper = new Cropper(image, {
      aspectRatio: (width > height ?? true) ? 1.77 : 0.66,
      background: false,
      cropBoxResizable: false,
      dragMode: 'move',
      minCanvasWidth: 200,
      minCanvasHeight: 200,
      viewMode: 1,
    });
  }

  var onFileSelected = function (evt) {
    const fileInput = evt.target;
    const files = Array.from(evt.target.files).map((file) => file.name);
    const placeholder =
      fileInput.getAttribute('data-placeholder') || fileInput.placeholder;

    // Store original placeholder
    fileInput.setAttribute('data-placeholder', placeholder);

    // Update current placeholder
    if (files.length === 1) {
      fileInput.placeholder = files[0].replace(/.*[\/\\]/, '');
    } else if (files.length > 1) {
      fileInput.placeholder = `${files.length} files`;
    } else {
      fileInput.placeholder = placeholder;
    }

    if (evt.target.files && evt.target.files[0])
      previewImage(evt.target.files[0], fileInput);
  };

  $('input[type="file"]').each((index, el) =>
    $(el).on('change', onFileSelected)
  );

  $('video.protected').attr('controlsList', 'nodownload');
  $('video.protected, img.protected').bind('contextmenu', () => false);
};

$(document).on('turbolinks:load', directUploadsInit);

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsDataURL(blob);
  });
}